<template>
  <h3 class="title underline">{{ car.model }}</h3>
  <ul>
    <li>
      <span>מחיר</span><span>{{ formattedPrice('price') }}</span>
    </li>
    <li>
      <span>שנת דגם</span><span>{{ car.year }}</span>
    </li>
    <li>
      <span>ק"מ</span><span>{{ car.km }}</span>
    </li>
    <li>
      <span>יד</span><span>{{ car.previewsOwners }}</span>
    </li>
  </ul>
</template>

<script>
export default {
  methods: {
    formattedPrice(key) {
      const currencySymbol = '₪'; 
      return currencySymbol + this.car[key].toLocaleString();
    }
  },
  props: {
    car: {
      required: true,
    },
  }
};
</script>
